import { useTranslation } from 'react-i18next'
import { i18n } from '@fs/zion-locale'

export default function useTemplelinks({ nonReligiousMode, canAddPersonalData, canSeeTemple }) {
  const { t } = useTranslation()
  return {
    id: 'temples',
    title: t('feedback.category.temple', 'Temple and Callings'),
    hidden: !canSeeTemple,
    subNav: [
      {
        id: 'reservations',
        text: t('nav.links.temples.reservations', 'My Reservations'),
        url: `/temple/reservations`,
        linkName: 'ff_temples_reservations',
        dataTestId: 'ff_my_reservations',
        isNew: false,
      },
      {
        id: 'ordReady',
        text: t('nav.links.temples.ordReady', 'Ordinances Ready'),
        url: `/temple/ordinances-ready`,
        linkName: 'ff_temples_ordReady',
        dataTestId: 'ff_ordinances_ready',
        isNew: false,
      },
      {
        id: 'resPolicy',
        text: t('nav.links.temples.resPolicy', 'Reservation Policies'),
        url: `/${i18n.language}/help/helpcenter/article/individuals-for-whom-i-can-request-temple-ordinances`,
        linkName: 'ff_temples_resPolicy',
        dataTestId: 'ff_reservation_policies',
        isNew: false,
      },
      {
        id: 'tAppt',
        text: t('nav.links.temples.tAppt', 'Temple Appointments'),
        url: `/temple/appointment`,
        linkName: 'ff_temples_tAppt',
        dataTestId: 'ff_temple_appts',
        isNew: false,
      },
      {
        id: 'fhCallings',
        text: t('nav.links.temples.fhCallings', 'Family History Callings'),
        url: `https://www.churchofjesuschrist.org/study/handbooks-and-callings/ward-or-branch-callings/temple-and-family-history?lang=eng`,
        linkName: 'ff_temples_fhCalls',
        dataTestId: 'ff_fh_callings',
        isNew: false,
        hidden: nonReligiousMode,
      },
      {
        id: 'helperRsc',
        text: t('nav.links.involved.helperRsc', 'Helper Resources'),
        url: '/help/helper',
        linkName: 'ff_inv_helperRsc',
        dataTestId: 'ff_helper_resources',
        isNew: false,
        hidden: !canAddPersonalData,
      },
    ],
  }
}
